import { render, staticRenderFns } from "./CustomEle.vue?vue&type=template&id=673b9286&scoped=true&"
import script from "./CustomEle.vue?vue&type=script&lang=js&"
export * from "./CustomEle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b9286",
  null
  
)

export default component.exports